import React from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {images} from '../../../assets/icons';
import {Link} from '../../../shared/components/link';
import {Text} from '../../../shared/components/text';

import {Props} from './model';
import {GetStyles} from './style';

export default ({screen, title, href}: Props) => {
  const nav = useNavigation();
  const styles = GetStyles();

  const imageBg = (
    <View style={styles.image}>
      <images.SocialSupportButtonPattern
        width={styles.image.width}
        height={styles.image.height}
        hideForVisuallyImpaired
      />
    </View>
  );
  return (
    <Link
      testID={`social-support-measure-to-${href}-link-id`}
      navigate={nav.navigate}
      screen={screen}
      style={styles.container}
      dataSetClass='link-filled'>
      <>
        <Text style={styles.text}>{title}</Text>
        {imageBg}
      </>
    </Link>
  );
};
